export default __webpack_public_path__ + "static/media/56.e7dc6d14.jpg";